/** 文末不再追加 Related / Help center 块，内链写在各篇正文里 */
export const BLOG_BODY_TAIL = {}
